/* ==========================================================================
   HUSSIENI HOME — PRODUCT PAGE
   Two small behaviours only: the quantity stepper and the mobile call to
   action. The view switch is wired by the 3D file, because the buttons are the
   same ones that open and close the viewer and there should be one owner of
   that state.

   The sticky bar never adds anything itself. It asks the real form to submit,
   so the cart can only ever receive what the form holds — there is no second
   path to the cart that could drift from what is on screen.
   ========================================================================== */
(function () {
  'use strict';

  function quantity(root) {
    var input = root.querySelector('[data-hh-qty-input]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;

    function clamp() {
      // Read on every clamp: the delivery choice can change the ceiling.
      var max = parseInt(input.getAttribute('max'), 10) || 999;
      var v = parseInt(input.value, 10);
      if (isNaN(v)) v = min;
      v = Math.min(max, Math.max(min, v));
      input.value = v;
      root.querySelectorAll('[data-hh-qty-step]').forEach(function (b) {
        var d = parseInt(b.dataset.hhQtyStep, 10);
        b.disabled = (d < 0 && v <= min) || (d > 0 && v >= max);
      });
    }

    root.querySelectorAll('[data-hh-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || min) + parseInt(b.dataset.hhQtyStep, 10);
        clamp();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    input.addEventListener('change', clamp);
    input.addEventListener('blur', clamp);
    clamp();
  }

  function stickyBar() {
    var bar = document.querySelector('[data-hh-stickybar]');
    var form = document.querySelector('[data-hh-pdp-form], .hh-pdp__form');
    if (!bar || !form) return;
    var anchor = form.querySelector('[data-hh-submit]');
    if (!anchor) return;

    bar.hidden = false;
    var go = bar.querySelector('[data-hh-stickybar-go]');
    if (go) {
      go.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(anchor);
        else anchor.click();
      });
    }

    // Measured on scroll rather than observed.
    //
    // An IntersectionObserver only fires when the intersection state CHANGES.
    // On a long product page the button can go from below the viewport to above
    // it within one scroll without ever intersecting, so no callback fires and
    // the bar never appears. That is exactly what happened at 390px wide, while
    // 412px happened to pass through an intersecting state and looked fine.
    // Reading the position directly has no such gap.
    var queued = false;
    function measure() {
      queued = false;
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-shown', r.bottom < 0);
    }
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(measure);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    measure();
  }

  /* Delivery choice: In Stock versus made to order, for a piece that is both.
     It rewrites the three line item properties the form already carries, so
     the order records exactly what the customer chose and was promised. An
     In Stock piece is supplied as shown, so the configurator is disabled —
     a disabled fieldset submits nothing — and re-synced when it comes back. */
  function fulfilment() {
    var box = document.querySelector('[data-hh-ff]');
    if (!box || box.dataset.hhFfReady === '1') return;
    box.dataset.hhFfReady = '1';
    var form = box.closest('form');
    var page = box.closest('.hh-pdp') || document;
    var qty = form.querySelector('[data-hh-qty-input]');
    var cfg = form.querySelector('[data-hh-ff-cfg]');
    var submit = form.querySelector('[data-hh-submit]');
    var prop = function (k) { return form.querySelector('[data-hh-ff-prop="' + k + '"]'); };

    function apply() {
      var picked = box.querySelector('input[name="hh_ff_choice"]:checked');
      var mode = picked ? picked.value : 'in_stock';
      var inStock = mode === 'in_stock';

      prop('type').value = inStock ? 'IN STOCK' : 'STANDARD MADE TO ORDER';
      prop('line').value = inStock ? box.dataset.inLine : box.dataset.stdLine;
      prop('lead').value = inStock ? box.dataset.inLead : box.dataset.stdLead;
      // The stock allocation travels on the line only for an In Stock order,
      // and an In Stock order is always for the variant that is in stock.
      var entry = prop('entry');
      if (entry) entry.disabled = !inStock;
      var variant = form.querySelector('[data-hh-ff-variant]');
      if (variant) variant.value = inStock ? box.dataset.inVariant : box.dataset.stdVariant;

      page.querySelectorAll('[data-hh-ff-show]').forEach(function (el) {
        el.hidden = el.getAttribute('data-hh-ff-show') !== mode;
      });

      if (cfg) {
        cfg.disabled = inStock;
        cfg.hidden = inStock;
        if (!inStock) {
          var any = cfg.querySelector('.hh-cfg__radio:checked') || cfg.querySelector('.hh-cfg__radio');
          if (any) any.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      // The configurator may have held the button back for a quote; that
      // never applies to a finished piece that is sold as shown.
      if (inStock && submit) {
        submit.hidden = false;
        submit.disabled = false;
        submit.removeAttribute('aria-disabled');
      }

      if (qty) {
        qty.setAttribute('max', inStock ? box.dataset.inMax : box.dataset.stdMax);
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    box.addEventListener('change', apply);
    apply();
    // The configurator initialises on its own deferred script; settle after it.
    window.addEventListener('load', apply);
  }

  function boot() {
    document.querySelectorAll('[data-hh-qty]').forEach(quantity);
    stickyBar();
    fulfilment();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
